module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list d-flex h-100 flex-column align-items-center px-3"
  }, [(!_vm.getSlimFilters || _vm.getIsLoadingEvents) ? _c('div', {
    staticClass: "d-flex flex-column align-items-center pt-5 p-3 text-center"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Loading Filters")]), _vm._v(" "), _c('loader', {
    attrs: {
      "size": "small"
    }
  })], 1) : _c('div', {
    staticClass: "d-flex flex-column w-100 h-100 pt-4"
  }, [_c('div', {
    staticClass: "w-100 flex-grow-1 overflow-auto"
  }, [_c('calendar-filters', {
    staticClass: "mb-3",
    on: {
      "change": _vm.filtersChanged
    }
  }), _vm._v(" "), _c('product-filter', {
    attrs: {
      "products": _vm.getProductsShowingOnCalendar
    },
    on: {
      "change": function($event) {
        return _vm.updateFilters()
      },
      "loaded": function($event) {
        return _vm.updateFilters()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "border-top-light mt-2"
  }, [_c('div', {
    staticClass: "w-100 mt-2"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.locations,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "preserve-search": false,
      "track-by": "id",
      "label": "name",
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "",
      "placeholder": "All Locations",
      "open-direction": "top"
    },
    on: {
      "input": _vm.updateFilters
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var values = ref.values;
        var search = ref.search;
        var isOpen = ref.isOpen;

        return [(values.length > 1) ? _c('span', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip.auto",
            value: (values.length + ' products selected'),
            expression: "values.length + ' products selected'",
            modifiers: {
              "auto": true
            }
          }],
          staticClass: "multiselect__single"
        }, [_vm._v(_vm._s(values.length) + " locations selected")]) : (values.length == 1) ? _c('span', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip.auto",
            value: (values[0].name),
            expression: "values[0].name",
            modifiers: {
              "auto": true
            }
          }],
          staticClass: "multiselect__single"
        }, [_vm._v(_vm._s(values[0].name) + " ")]) : _vm._e()]
      }
    }, {
      key: "option",
      fn: function(props) {
        return [(_vm.selectedLocations.filter(function (i) {
          return i.name == props.option.name
        }).length) ? _c('i', {
          staticClass: "far fa-check-square"
        }) : _c('i', {
          staticClass: "far fa-square"
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip.auto",
            value: (props.option.name),
            expression: "props.option.name",
            modifiers: {
              "auto": true
            }
          }]
        }, [_vm._v(_vm._s(props.option.name))])]
      }
    }]),
    model: {
      value: (_vm.selectedLocations),
      callback: function($$v) {
        _vm.selectedLocations = $$v
      },
      expression: "selectedLocations"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "w-100 mt-2"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.resources,
      "multiple": true,
      "taggable": false,
      "close-on-select": false,
      "clear-on-select": false,
      "preserve-search": false,
      "track-by": "id",
      "label": "name",
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "",
      "placeholder": "All Resources",
      "open-direction": "top"
    },
    on: {
      "input": _vm.updateFilters
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var values = ref.values;
        var search = ref.search;
        var isOpen = ref.isOpen;

        return [(values.length > 1) ? _c('span', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip.auto",
            value: (values.length + ' products selected'),
            expression: "values.length + ' products selected'",
            modifiers: {
              "auto": true
            }
          }],
          staticClass: "multiselect__single"
        }, [_vm._v(_vm._s(values.length) + " resources selected")]) : (values.length == 1) ? _c('span', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip.auto",
            value: (values[0].name),
            expression: "values[0].name",
            modifiers: {
              "auto": true
            }
          }],
          staticClass: "multiselect__single"
        }, [_vm._v(_vm._s(values[0].name))]) : _vm._e()]
      }
    }, {
      key: "option",
      fn: function(props) {
        return [(_vm.selectedResources.filter(function (i) {
          return i.id == props.option.id
        }).length) ? _c('i', {
          staticClass: "far fa-check-square"
        }) : _c('i', {
          staticClass: "far fa-square"
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip.auto",
            value: (props.option.name),
            expression: "props.option.name",
            modifiers: {
              "auto": true
            }
          }]
        }, [_vm._v(_vm._s(props.option.name))])]
      }
    }]),
    model: {
      value: (_vm.selectedResources),
      callback: function($$v) {
        _vm.selectedResources = $$v
      },
      expression: "selectedResources"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "w-100 d-flex mt-2"
  }, [_c('button', {
    staticClass: "btn tertiary wide reset",
    on: {
      "click": function($event) {
        return _vm.renderFilters(_vm.getStoredEvents, true)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tClear All\n\t\t\t\t\t")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67382020"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/Filters.vue
// module id = 2378
// module chunks = 0